var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCross = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(8 3.05) rotate(45)"
}, /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "2px",
  x2: 7,
  y2: 7
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "2px",
  x1: 7,
  y2: 7
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cross.d30af9cb.svg";
export { ForwardRef as ReactComponent };